module.exports = __webpack_public_path__ + "img/soft-grove-vanity-1.034f79f4.jpeg";